/**
 * Loading skeleton component for job detail page
 * Uses theme-aware colors for dark surface background
 */
import React from 'react'

export const JobSkeleton: React.FC = () => {
  return (
    <div
      className="min-h-screen bg-surface"
      data-testid="job-skeleton"
      aria-label="Loading job details"
    >
      {/* Dark hero skeleton */}
      <div className="animate-pulse max-w-4xl mx-auto px-4 pt-8 pb-12">
        <div className="h-8 bg-surface-elevated rounded w-32 mb-8" />
        <div className="h-10 bg-surface-elevated rounded w-3/4 mb-4" />
        <div className="flex gap-2 flex-wrap mb-6">
          <div className="h-7 bg-surface-elevated rounded-full w-24" />
          <div className="h-7 bg-surface-elevated rounded-full w-24" />
          <div className="h-7 bg-surface-elevated rounded-full w-24" />
        </div>
        <div className="h-12 bg-surface-elevated rounded w-40" />
      </div>

      {/* Card content skeleton */}
      <div className="max-w-4xl mx-auto px-4 -mt-4">
        <div className="animate-pulse bg-card rounded-lg shadow-lg border border-card-border p-6 md:p-8 space-y-8">
          <div className="space-y-3">
            <div className="h-6 bg-gray-200 rounded w-1/3" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>

          <div className="space-y-3">
            <div className="h-6 bg-gray-200 rounded w-1/3" />
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="h-4 bg-gray-200 rounded w-5/6" />
              <div className="h-4 bg-gray-200 rounded w-4/5" />
            </div>
          </div>

          <div className="space-y-3">
            <div className="h-6 bg-gray-200 rounded w-1/3" />
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="h-4 bg-gray-200 rounded w-5/6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
